import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useMemo, useState, } from 'react';
import StyledForm, { SubLabel } from '@bookingForm/styles/form';
import SelectedOption from '@genericBookings/components/SelectedOption/SelectedOption';
import { useCallback, useEffect } from 'preact/compat';
function FormStep(props) {
    const { children, name, label, completedLabel = label, sublabel, labelIcon, hideLabelOnEntry, selectedOptionTitle, selectedOptionIcon, half, showLabels, layout, value, onHandleFormat, onHandleClick, isWide, className, step: { isComplete: isStepCompleted }, } = props;
    const [formattedSelectedValue, setFormattedSelectedValue] = useState(value ?? '');
    const handleFormat = useCallback(() => {
        if (value && onHandleFormat) {
            const formatted = onHandleFormat(value);
            setFormattedSelectedValue(formatted);
        }
        else if (value) {
            setFormattedSelectedValue(value);
        }
    }, [value, onHandleFormat]);
    useEffect(handleFormat, [handleFormat]);
    const labelElement = useMemo(() => {
        const labelIsHidden = (!isStepCompleted)
            ? (hideLabelOnEntry || !showLabels)
            : !showLabels;
        const shouldShowCompletedlabel = isStepCompleted && layout === 'winter-wonderland';
        return (_jsxs(StyledForm.Label, { className: isStepCompleted ? 'step--complete' : '', htmlFor: name, layout: layout, isHidden: labelIsHidden, hasSublabel: sublabel !== undefined, children: [labelIcon, _jsx("span", { children: shouldShowCompletedlabel ? completedLabel : label }), sublabel && _jsx(SubLabel, { children: sublabel })] }));
    }, [hideLabelOnEntry, isStepCompleted, label, labelIcon, name, showLabels]);
    let element = (_jsxs(_Fragment, { children: [labelElement, children] }));
    if (isStepCompleted) {
        element = (_jsxs(StyledForm.SelectedOptionWrapper, { children: [labelElement, _jsx(SelectedOption, { icon: selectedOptionIcon, onClicked: () => {
                        if (onHandleClick) {
                            onHandleClick();
                        }
                    }, optionType: selectedOptionTitle, value: formattedSelectedValue ?? '', layout: layout })] }));
    }
    // TODO: move this over to calendar form step
    return (_jsx(StyledForm.Group
    // isCalendar={isCalendarAndOpen}
    , { 
        // isCalendar={isCalendarAndOpen}
        isWide: isWide, className: className, 
        // isWide={formStage === FormStage.Session && (layout === 'winter-wonderland' || layout === 'horizontal')}
        half: half, children: element }));
}
FormStep.defaults = {
    value: undefined,
    onHandleFormat: undefined,
    maybeAfterLabelElement: undefined,
    isWide: false,
    className: '',
    completedLabel: undefined,
    selectedOptionIcon: undefined,
};
export default FormStep;
